import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  View, SafeAreaView, StatusBar, ScrollView, StyleSheet, Text,
} from 'react-native';
import HeaderBackButton from '../components/HeaderBackButton';
import APMCard from '../components/APMCard';
import StatusTypes from '../store/types';
import trainingActions from '../actions/trainingActions';
import APMStyles from '../styles';

function Workouts({ navigation }) {
  const status = useSelector((state) => state.training.status);
  const workouts = useSelector((state) => state.training.workouts);
  const dispatch = useDispatch();

  useEffect(() => {
    if (status === StatusTypes.getExercisesPending) {
      console.log('loading');
    } else if (status === StatusTypes.getExercisesSuccess) {
      navigation.navigate('Exercises');
    } else if (status === StatusTypes.getExercisesFail) {
      console.log('error');
    }
  }, [status, navigation]);

  function getExercises(workoutName) {
    dispatch(trainingActions.getExercises(workoutName));
  }

  return (
    <View style={styles.container}>
      <SafeAreaView style={styles.header}>
        <StatusBar barStyle="dark-content" />
        <HeaderBackButton style={styles.header} navigation={navigation} />
      </SafeAreaView>

      <View style={styles.banner}>
        <Text style={styles.title}>SELECT WORKOUT</Text>
      </View>

      <View style={styles.content}>
        <ScrollView
          horizontal={false}
          style={styles.scrollView}
        >
          {
            workouts && workouts.map((workout) => (
              <APMCard
                key={workout.name}
                title={workout.name}
                backgroundImg={workout.img}
                onPress={() => getExercises(workout.name)}
              />
            ))
          }
        </ScrollView>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: APMStyles.colors.background,
  },
  header: {
    flex: 1,
  },
  banner: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    flex: 10,
  },
  title: {
    letterSpacing: 6,
    fontSize: APMStyles.typography.title,
    color: APMStyles.colors.text,
  },
});

export default Workouts;
